module.exports = __webpack_public_path__ + "static/fx_3.ed99c499.jpg";